import sieviApi from "@/api/sieviApi"
import useFunctions from "@/composables/useFunctions"
const { deleteDifferenceTimezone } = useFunctions()
// export const myAction = async ( { commit } ) => {

// }

export const obtainHfsDocente = async ( { commit }, { id, contratoId} ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/docente/hfs/${id}/${contratoId}`)
        if (data.ok) {
            commit('setHfs', data.hfs)
            return { ok: true, message: data.message }
        } else {
            commit('setHfs', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainHfsResponsable = async ( { commit }, { id, campusId} ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/responsable/hfs/${id}/${campusId}`)
        if (data.ok) {
            commit('setHfs', data.hfs)
            return { ok: true, message: data.message }
        } else {
            commit('setHfs', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainHfsAuditor = async ( { commit }, { campusId, programId, teacherId, contractId, periodId } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/hfs/${campusId}/${programId}/${teacherId}/${contractId}/${periodId}`)
        if (data.ok) {
            commit('setHfs', data.hfs)
            return { ok: true, message: data.message }
        } else {
            commit('setHfs', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainHfsAuditorReports = async ( { commit } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/reportes/hfs`)
        if (data.ok) {
            commit('setHfs', data.hfs)
            return { ok: true, message: data.message }
        } else {
            commit('setHfs', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const generateReportAuditor = async (_, {hfs, programs, period, weeks, state}) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/reportes/exportar/${hfs}/${programs}/${period}/${weeks}/${state}`, {responseType: 'blob'})  
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `reporteAuditor-${deleteDifferenceTimezone(new Date()).toLocaleDateString().replace('.','_')}.xlsx`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        return { ok: true }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const generateReportViewAuditor = async ({commit}, {hfs, programs, period, weeks, state}) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/reportes/generar/${hfs}/${programs}/${period}/${weeks}/${state}`)  
        if (data.ok) {
            commit('setReport', data.reportes)
            return { ok: true, message: data.message }
        } else {
            commit('setReport', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const generateReportResponsable = async (_, {hfs, programs, period, weeks, state}) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/responsable/reportes/exportar/${hfs}/${programs}/${period}/${weeks}/${state}`, {responseType: 'blob'})  
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `reporteResponsable-${deleteDifferenceTimezone(new Date()).toLocaleDateString().replace('.','_')}.xlsx`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        return { ok: true }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const generateReportViewHfs = async ({commit}, {idHfs, idPeriod, campusId}) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/reponsable/hfs/reporte/consultar/${idHfs}/${idPeriod}/${campusId}`)
        if (data.ok) {
            commit('setReport', data.reportes)
            return { ok: true, message: data.message }
        } else {
            commit('setReport', [])
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const generateReportViewResponsable = async ({commit}, {hfs, programs, period, weeks, state}) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/responsable/reportes/generar/${hfs}/${programs}/${period}/${weeks}/${state}`)  
        if (data.ok) {
            commit('setReport', data.reportes)
            return { ok: true, message: data.message }
        } else {
            commit('setReport', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainHfsUser = async ( { commit }, id ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/usuarios/contrato/hfs/${id}`)
        if (data.ok) {
            commit('setHfs', data.hfs)
            return { ok: true, message: data.message }
        } else {
            commit('setHfs', [])
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const addHfsUser = async ( { commit }, { form } ) => {
    const hfsUserForm = {
        hfs_id: form.hfs_id,
        contrato_id: form.contrato_id,
        horasTotales: form.horasTotales,
        periodo_id: form.periodo_id,
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/administrador/usuarios/contrato/hfs/agregar`, hfsUserForm)
        if (data.ok) {
            commit('contracts/addHfsUser', hfsUserForm, { root: true })
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const resetHfsUser = async ({ commit }, { form }) => {
    const hfsUserForm = {
        hfs_id: form.hfs_id,
        contrato_id: form.contrato_id,
        horasTotales: 0,
        periodo_id: form.periodo_id,
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/administrador/usuarios/contrato/hfs/agregar`, hfsUserForm)
        if (data.ok) {
            commit('contracts/addHfsUser', hfsUserForm, { root: true })
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const obtainTypeHfsAdministrador = async ( { commit } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/tipoHfs`)
        if (data.ok) {
            commit('setTypeHfs', data.tipoHfs)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const createTypeHfs = async ( _, { form } ) => {
    const typeHfsForm = {
        nombre: form.name,
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/administrador/tipoHfs`, typeHfsForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
} 

export const editTypeHfs = async ( _, { form } ) => {
    const typeHfsForm = {
        nombre: form.name
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/tipoHfs/${form.id}`, typeHfsForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const deleteTypeHfs = async ( _, idTypeHfs ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.delete(`/api/administrador/tipoHfs/${idTypeHfs}`)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}